import { getTeamCountry } from "./getTeamCountry";
import { enumValues } from "./enumUtils";
import { Country } from "../model/Country";
const sortStatistics = (statistics, orderBy) => [...orderBy].reverse().forEach(name => statistics.sort((s1, s2) => s2[name] - s1[name]));
export const createSellersStatistics = (payouts, orderBy) => {
    const statistics = payouts.reduce((sellers, payout) => {
        if (payout.username && payout.userDisplayName) {
            const seller = sellers.find(ss => ss.username === payout.username);
            if (seller) {
                seller.amount += payout.amount;
                seller.count++;
            }
            else {
                sellers.push({
                    amount: payout.amount,
                    country: getTeamCountry(payout.team),
                    username: payout.username,
                    userDisplayName: payout.userDisplayName,
                    count: 1,
                    orderBy
                });
            }
        }
        return sellers;
    }, []);
    [...orderBy].reverse().forEach(name => statistics.sort((s1, s2) => s2[name] - s1[name]));
    return statistics;
};
export const createCountryStatistics = (payouts, orderBy) => {
    const statistics = payouts.reduce((countries, payout) => {
        if (getTeamCountry(payout.team)) {
            const country = countries.find(cs => cs.country === getTeamCountry(payout.team));
            country.amount += payout.amount;
            country.count += 1;
        }
        return countries;
    }, enumValues(Country).map(country => ({ country, amount: 0, count: 0, orderBy })));
    sortStatistics(statistics, orderBy);
    return statistics;
};
